import { render, staticRenderFns } from "./article_transferer_details.vue?vue&type=template&id=44756cef&"
import script from "./article_transferer_details.vue?vue&type=script&lang=js&"
export * from "./article_transferer_details.vue?vue&type=script&lang=js&"
import style0 from "./article_transferer_details.vue?vue&type=style&index=0&id=44756cef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports